export default __webpack_public_path__ + "static/media/HIV-EXPOSURE.75e551dc.png";